import { Link } from "react-router-dom";
import { slugify, countProducts } from "../utils/helpers";
import { handleImageError, PLACEHOLDER_IMG } from "../utils/imageFallback";
import "./CategoryCard.css";

export default function CategoryCard({ name, data }) {
  const count = countProducts(data?.subcategories ?? {});

  return (
    <Link
      to={`/category/${slugify(name)}`}
      className="category-modern-card"
      aria-label={`${name} — ${count} products`}
    >
      <div className="category-image-wrap">
        <img
          src={data?.img || PLACEHOLDER_IMG}
          alt=""
          loading="lazy"
          decoding="async"
          onError={handleImageError}
        />
      </div>

      <div className="category-text">
        <h3>{name}</h3>
        <p>{count} products</p>
      </div>
    </Link>
  );
}
